import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getShoppingCartRequest = () => ({ type: 'GET_SHOPPING_CART_REQUEST' })
export const getShoppingCartSuccess = (data) => ({ type: 'GET_SHOPPING_CART_SUCCESS', data })
export const getShoppingCartFailure = (error) => ({ type: 'GET_SHOPPING_CART_FAILURE', error })

export const getCheckoutRequest = () => ({ type: 'GET_CHECKOUT_REQUEST' })
export const getCheckoutSuccess = (data) => ({ type: 'GET_CHECKOUT_SUCCESS', data })
export const getCheckoutFailure = (error) => ({ type: 'GET_CHECKOUT_FAILURE', error })

export const getShoppingCart = () => {
  return (dispatch) => {
    dispatch(getShoppingCartRequest())
    fetch(URL.BASE_URL + URL.END_POINT.shoppingcart, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getShoppingCartSuccess(data))
      })
      .catch((error) => {
        dispatch(getShoppingCartFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const getCheckout = () => {
  return (dispatch) => {
    dispatch(getCheckoutRequest())
    fetch(URL.BASE_URL + URL.END_POINT.checkout, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getCheckoutSuccess(data))
      })
      .catch((error) => {
        dispatch(getCheckoutFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  cartItems: [],
  checkoutItems: [],
  loading: false,
  error: null,
}

export const shoppingCartReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_SHOPPING_CART_REQUEST':
    case 'GET_CHECKOUT_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_SHOPPING_CART_SUCCESS':
      return { ...state, cartItems: action.data.data, loading: false, error: null }
    case 'GET_CHECKOUT_SUCCESS':
      return { ...state, checkoutItems: action.data.data, loading: false, error: null }
    case 'GET_SHOPPING_CART_FAILURE':
    case 'GET_CHECKOUT_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
